import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import './styles.scss';

type PropsType = {
    label?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
    error?: string | boolean;
};

export const UiFormControl = observer(function UiFormControl({
    label, children, style, className,error
}: PropsType) {
    const classNames = classnames('ui-new-form-control', className, {
        'ui-new-form-control--error': !!error
    });

    return (
        <div className={classNames} style={style}>
            <div className="ui-new-form-control__label">{label}</div>
            <div className="ui-new-form-control__inner">
                {children}
            </div>
            {error && <div className="ui-new-form-control__error">{error}</div>}
        </div>
    );
});
